import { createTheme } from "@material-ui/core";
import { aaaCustomColors } from "./aaaCustomColors";

export const aaaTheme = createTheme({
    palette: {
        primary: {
            main: aaaCustomColors.primary
        },
        error: {
            main: aaaCustomColors.error
        }
    },
    typography: {
        fontFamily: "Inter"
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                backgroundColor: aaaCustomColors.primary,
                "&:hover": {
                    backgroundColor: aaaCustomColors.primaryDark
                }
            },
            root: {
                textTransform: "none",
                borderRadius: 0,
                padding: "18px 26px 18px 26px"
            }
        },
        MuiCheckbox: {
            root: {
                color: aaaCustomColors.disabledElements,
                padding: 0
            },
            colorSecondary: {
                "&.Mui-checked": {
                    color: aaaCustomColors.primary
                }
            }
        },
        MuiPaper: {
            elevation1: {
                boxShadow: "3px 5px 4px rgba(171, 171, 171, 0.1)"
            }
        },
        MuiBadge: {
            colorPrimary: {
                color: aaaCustomColors.white
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                backgroundColor: "transparent"
            },
            multiline: {
                "&.Mui-focused": {
                    padding: "25px 12px 8px"
                }
            }
        },
        MuiTextField: {
            root: {
                borderRadius: 0,
                backgroundColor: aaaCustomColors.fieldBackgroundColor
            }
        },
        MuiInputBase: {
            root: {
                height: 56,
                "&.Mui-focused": {
                    borderTop: "2px solid transparent",
                    borderBottom: `2px solid ${aaaCustomColors.primary}`
                }
            },
            multiline: {
                height: "auto"
            }
        },
        MuiAutocomplete: {
            inputRoot: {
                paddingTop: "12px !important",
                paddingBottom: 12,
                height: "unset",
                minHeight: 56,
                "&.Mui-focused": {
                    paddingBottom: 10,
                    paddingTop: "10px !important"
                }
            }
        },
        MuiSelect: {
            icon: {
                fill: aaaCustomColors.primary
            }
        },
        MuiFormLabel: {
            root: {
                color: aaaCustomColors.body1Dark,
                "&.Mui-focused": {
                    color: aaaCustomColors.body1Dark
                }
            },
            colorSecondary: {
                "&.Mui-focused": {
                    color: aaaCustomColors.primary
                }
            }
        },
        MuiListItem: {
            root: {
                "&.Mui-disabled": {
                    opacity: 1
                }
            }
        },
        MuiToolbar: {
            root: {
                "& .MuiPickersToolbarText-toolbarTxt": {
                    color: "#ffffff8a"
                },
                "& .MuiPickersToolbarText-toolbarBtnSelected": {
                    color: aaaCustomColors.white
                }
            }
        },
        MuiPickersDay: {
            daySelected: {
                color: aaaCustomColors.white
            }
        },
        MuiPickersClockNumber: {
            clockNumberSelected: {
                color: aaaCustomColors.white
            }
        },
        MuiTab: {
            root: {
                textTransform: "none"
            },
            textColorInherit: {
                opacity: 1,
                color: aaaCustomColors.body1Dark,
                "&.Mui-selected": {
                    color: aaaCustomColors.primary,
                    fontWeight: 700
                }
            }
        },
        MuiTableSortLabel: {
            root: {
                "&.MuiTableSortLabel-active": {
                    color: "unset"
                }
            }
        },
        MuiTableRow: {
            head: {
                backgroundColor: aaaCustomColors.fieldBackgroundColor
            }
        },
        MuiSnackbarContent: {
            root: {
                backgroundColor: aaaCustomColors.errorBackground,
                color: aaaCustomColors.error,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `1px solid ${aaaCustomColors.error}`
            }
        },
        MuiCardContent: {
            root: {
                "&.applicantCardInterviews": {
                    borderTop: `1px solid ${aaaCustomColors.dataUploadBorderColor}`
                }
            }
        }
    }
});
